export default "__VITE_ASSET__DmTOX0YT__"